// extracted by mini-css-extract-plugin
module.exports = {"landingBackground":"Landing_landingBackground__1nB29","landingLogo":"Landing_landingLogo__QOofy"};